import { Provider } from '@angular/core';
import { SIMULACAO_FINANCIAMENTO_REPOSITORY } from './repositories/simulacao-financiamento.repository';
import { SimulacaoFinanciamentoService } from './services/simulacao-financiamento.service';

export const SIMULACAO_FINANCIAMENTO_PROVIDERS: Provider[] = [
  {
    provide: SIMULACAO_FINANCIAMENTO_REPOSITORY,
    useClass: SimulacaoFinanciamentoService
  }
];
